// Auto-generated GetYourGuide location IDs
// Generated: 2026-01-02T05:42:36.250Z
// Total locations: 1041

export const GYG_LOCATION_IDS = {
  "3d museum of wonders": "163486",
  "7 mile beach, negril jamaica": "234930",
  "abu dhabi": "494",
  "addu city": "159180",
  "adelaide": "203",
  "agadir": "1413",
  "agafay": "166143",
  "airlie beach": "868",
  "aj hackett cairns": "93059",
  "akrotiri santorini castle": "184560",
  "alas harum bali": "167102",
  "algarve": "66",
  "alhambra": "2772",
  "alicante": "414",
  "alto vista chapel, aruba": "165746",
  "amsterdam": "36",
  "andamanda phuket": "167751",
  "anne frank house": "2697",
  "antalya": "172",
  "antelope canyon": "4744",
  "antibes": "5075",
  "antilla shipwreck, aruba": "164758",
  "antwerp": "1028",
  "ao nang": "89867",
  "ao thalane": "9476",
  "aonang fiore zipline": "204963",
  "aquaworld cancun": "87612",
  "aquila game reserve": "9887",
  "arcadia queensland": "227971",
  "areguling beach lombok": "221348",
  "arraial do cabo": "95354",
  "arrecifes de cozumel national park": "161635",
  "aruba": "169061",
  "aruba airport": "165538",
  "aruba aloe factory museum": "200617",
  "aruba dam": "246563",
  "aruba ostrich farm": "179650",
  "aruba protestant church": "238102",
  "aruba region": "202758",
  "athens": "91",
  "atlanta": "503",
  "atlantis bahamas": "119010",
  "atlantis dunes": "187732",
  "atv cancun monkeys": "210114",
  "auckland": "822",
  "auschwitz": "1069",
  "australian outback": "87282",
  "aveiro": "2459",
  "awesome flight cozumel": "237514",
  "ayia napa": "124743",
  "badaling great wall": "4272",
  "bagatelle key west": "129963",
  "bahamas": "169063",
  "bahamas cake factory": "169970",
  "bahamas heritage museum": "251303",
  "bahamas ntl art gallery": "4042",
  "baie sainte anne": "123205",
  "bailey town": "250734",
  "balashi gold mills, aruba": "165742",
  "bali": "347",
  "bali bird park": "50312",
  "bali glass bridge": "227454",
  "bali hai pier": "184978",
  "bali hai restaurant": "115047",
  "bali museum": "168702",
  "bali nusa dua theatre": "84550",
  "bali safari & marine park": "53736",
  "bali swing": "158531",
  "bali tarantula atv": "227347",
  "bali zoo": "83601",
  "bali, crete": "184194",
  "balicasag island": "114372",
  "balik pulau": "241401",
  "balikpapan": "157352",
  "bamberg": "2537",
  "banff": "284",
  "bangkok": "169",
  "barbados": "169066",
  "barbados museum": "178956",
  "barbados wildlife reserve": "227280",
  "barcelona": "45",
  "barron gorge": "97015",
  "barron river": "169662",
  "basel": "51",
  "bat cave, lombok": "252528",
  "bath": "517",
  "bathsheba": "226713",
  "bayside marketplace": "124953",
  "beijing": "186",
  "bel ombre": "110932",
  "belle mare": "182652",
  "bergen": "1132",
  "berlin": "17",
  "bernina train line": "96667",
  "biausevu": "179355",
  "big buddha phuket": "135822",
  "big putts ibiza": "238301",
  "biscayne bay": "10702",
  "blue bay": "189535",
  "blue dome church santorini": "146177",
  "blue pool krabi thailand": "194500",
  "bo-kaap": "143956",
  "bodufolhudhoo": "254183",
  "bogotá": "361",
  "bondi": "119275",
  "bondi beach": "1902",
  "bora bora": "32139",
  "bora bora cartagena": "187756",
  "bordeaux": "287",
  "boston": "260",
  "boulders beach": "3865",
  "bratislava": "765",
  "brickell": "167635",
  "bridgeclimb sydney": "129293",
  "bridgetown": "345",
  "brisbane": "300",
  "broadbeach": "90210",
  "broadwater, queensland": "214576",
  "bruges": "854",
  "bruges christmas market": "175081",
  "brunel's ss great britain": "118480",
  "brussels": "8",
  "bucharest": "111",
  "budapest": "29",
  "buenos aires": "1",
  "burj khalifa": "2703",
  "burleigh heads": "43242",
  "bursa": "1372",
  "butterfly sanctuary mariposario jardin magico": "166216",
  "byron bay": "1898",
  "cabo da roca": "2284",
  "cabo de gata": "124758",
  "cabo de gata-nijar": "96730",
  "cabo de la vela": "142494",
  "cabo engano": "3745",
  "cabo frio": "121720",
  "cabo girao cliff": "9353",
  "cabo girão skywalk": "169724",
  "cabo polonio": "245960",
  "cabo pulmo": "117915",
  "cabo rojo": "145418",
  "cabo san lucas": "306",
  "cabo san lucas port": "178881",
  "cabourg": "103314",
  "cahuita": "149254",
  "cairns": "298",
  "cairns airport": "114827",
  "cairns aquarium": "91725",
  "cairns botanic gardens": "165234",
  "cairns esplanade lagoon": "207221",
  "cairns harbour": "104034",
  "cairns koalas & creatures": "220667",
  "cairns museum": "227001",
  "cairns north": "214441",
  "cairo": "92",
  "calgary": "1783",
  "california": "560",
  "caminito del rey": "89646",
  "canary islands": "416",
  "canary lake": "128543",
  "canary wharf": "4667",
  "canava santorini distillery": "138313",
  "cancún": "150",
  "cancun ado bus station": "223739",
  "cancun airport": "148180",
  "cancun bus station": "183621",
  "cancun lighthouse": "193207",
  "cancun wax museum": "163457",
  "cancun's national park": "203223",
  "cancunito": "200134",
  "canopy river park": "205135",
  "cap malheureux": "174825",
  "cape of good hope": "3859",
  "cape town": "103",
  "cape town harbor": "178275",
  "cape town stadium": "3864",
  "cape wheel": "95007",
  "cappadocia": "1400",
  "captain hook cancun": "167624",
  "caribbean": "188677",
  "caribbean lake park": "176255",
  "caribbean moonshine": "233969",
  "caribbean sea": "173965",
  "carrara, queensland": "199861",
  "cartagena": "362",
  "casablanca": "244",
  "cave pool aruba": "165708",
  "central highlands, queensland": "214113",
  "central lombok regency": "235696",
  "chamarel": "2088",
  "chantilly": "2361",
  "chiang mai": "271",
  "chiang rai": "913",
  "chicago": "225",
  "chocomuseo": "164568",
  "clandestino rooftop": "253914",
  "clarence town": "197897",
  "clava cairns": "119730",
  "clementinum": "25912",
  "cleveland, queensland": "259286",
  "cockburn town": "185048",
  "coco bongo": "148306",
  "cologne": "19",
  "colosseum": "2619",
  "como": "101235",
  "compass cay, the bahamas": "180935",
  "coogee beach": "17625",
  "coolangatta": "181806",
  "copenhagen": "12",
  "coralina daylight club": "219673",
  "cordoba": "1689",
  "coron": "105241",
  "corralejo": "1725",
  "costa rica": "168995",
  "cozumel": "309",
  "cozumel airport": "165917",
  "cozumel central plaza": "173710",
  "cozumel marine park": "203226",
  "cozumel reef": "186641",
  "crater rim trail": "186513",
  "crete": "404",
  "crystal cascades": "148802",
  "curepipe": "110482",
  "currumbin": "50800",
  "cusco": "359",
  "da nang": "939",
  "dallas": "899",
  "dalt vila": "176312",
  "danube river": "104472",
  "darling harbour": "3731",
  "denarau island": "32403",
  "denver": "948",
  "dhangethi": "215540",
  "dhiffushi": "215536",
  "diamond cave": "193297",
  "diamond valley": "182699",
  "dinner in the sky phuket": "200643",
  "disneyland paris": "2603",
  "djerba": "302",
  "doha": "1885",
  "dolomites": "34573",
  "dominical": "216058",
  "dortmund": "136",
  "downtown": "5963",
  "dreamworld": "87276",
  "dresden": "20",
  "dubai": "173",
  "dubai airport": "113892",
  "dubai aquarium & zoo": "3333",
  "dubai butterfly garden": "165527",
  "dubai conservation rsrv": "3312",
  "dubai creek": "2704",
  "dubai dolphinarium": "3338",
  "dubai eye": "186217",
  "dubai fountain": "3305",
  "dubai frame": "87469",
  "dubai gold souk": "4841",
  "dubai islands": "167429",
  "dubai mall": "4308",
  "dubai marina": "3415",
  "dubai marina yacht club": "176587",
  "dubai safari park": "7609",
  "dublin": "31",
  "dubrovnik": "513",
  "dundee's restaurant on the waterfront": "104037",
  "dunmore town": "183693",
  "durants, saint james": "182719",
  "düsseldorf": "125",
  "duval street": "95678",
  "edenva ecotourism park": "205277",
  "edge": "158493",
  "edinburgh": "44",
  "edinburgh castle": "2592",
  "egyptian museum": "36970",
  "eiffel tower": "2600",
  "eiffel tower summit": "90114",
  "eindhoven": "32277",
  "el calafate": "544",
  "el gouna": "1051",
  "el malecón": "92261",
  "el nido": "974",
  "el santorini colombiano": "211699",
  "ella": "97539",
  "empire state building": "2608",
  "erfurt": "135",
  "ernest hemingway house": "86364",
  "essaouira": "877",
  "europa-park": "35327",
  "everglades": "1867",
  "extreme adventure cancun": "164771",
  "exuma cays, the bahamas": "180936",
  "fabrique des lumieres": "175620",
  "falmouth": "1266",
  "faro": "1238",
  "fátima": "98",
  "featherdale wildlife park": "6487",
  "ferrari world": "3681",
  "fes": "829",
  "fiji": "169098",
  "fiji museum": "142756",
  "fiji waterfall lemukih": "234468",
  "fit&fun cozumel": "192461",
  "fitts village": "182716",
  "fitzroy island": "3761",
  "five cays settlements": "247272",
  "fjellheisen cable car": "104406",
  "flic en flac": "110532",
  "florence": "32",
  "florianópolis": "246",
  "florida": "84",
  "florida keys sanctuary": "174710",
  "fort lauderdale": "1392",
  "foz do iguaçu": "497",
  "frankfurt": "21",
  "fraser island": "32184",
  "freeport": "961",
  "freiburg": "22",
  "fuerteventura": "419",
  "fukuoka": "32581",
  "fulidhoo": "209006",
  "funchal": "1026",
  "gatlinburg": "841",
  "gdansk": "1960",
  "geneva": "54",
  "genoa": "1009",
  "ghent": "1487",
  "gibbes": "182710",
  "gibraltar": "166",
  "gili air": "88775",
  "gili asahan": "226629",
  "gili gede": "97315",
  "gili islands": "2491",
  "gili kapal": "226579",
  "gili kedis": "218924",
  "gili kondo": "89615",
  "gili layar": "146665",
  "gili meno": "88772",
  "gili meno beach": "228934",
  "gili meno sea turtle": "213929",
  "gili nanggu": "89612",
  "gili pasir": "244321",
  "gili petel": "150129",
  "gili sudak": "218925",
  "gili tangkong": "226874",
  "gili trawangan": "88769",
  "gili trawangan ferry": "237973",
  "gilimanuk": "175534",
  "gilimanuk harbour": "229993",
  "glasgow": "438",
  "global village": "3348",
  "go hawaii watersports": "190707",
  "goa": "825",
  "gold coast": "842",
  "gold coast airport": "105196",
  "gold coast broadwater": "182678",
  "göreme": "984",
  "gothenburg": "479",
  "grace bay": "178164",
  "gran canaria": "418",
  "gran coyote golf": "245026",
  "granada": "207",
  "grand anse": "184416",
  "grand baie": "2072",
  "grand canyon": "489",
  "grand canyon park": "95984",
  "grand cayman": "571",
  "grand egyptian museum": "188477",
  "grand palladium jamaica": "201868",
  "grand turk's coral reef": "87448",
  "great barrier island": "165491",
  "great barrier reef": "159644",
  "great barrier reef drive": "185596",
  "great beguinage of leuven": "144431",
  "great blasket island": "161393",
  "great britain": "176824",
  "great buddha, japan": "165006",
  "great harbour buffet": "211108",
  "great lakes brewing": "123871",
  "great soca gorge": "226682",
  "great war island": "126383",
  "grindelwald": "1613",
  "gubeikou great wall": "96979",
  "ha long bay": "934",
  "hagia sophia": "2705",
  "hallstatt": "32535",
  "hamburg": "23",
  "hanoi": "205",
  "hard rock campo de golf": "246245",
  "hawaii": "85",
  "hawaii army museum": "141521",
  "hawaii capital district": "209262",
  "hawaii kai": "147732",
  "hawaii shark encounters": "220245",
  "hawaii state capitol": "179215",
  "hawaii supreme court": "160136",
  "hawaii tropical garden": "159249",
  "hawaii volcanoes ntl park": "4781",
  "hawaiian acres": "251919",
  "heart of santorini": "226516",
  "heidelberg": "24",
  "heineken experience": "3406",
  "hell, grand cayman": "211787",
  "helsinki": "13",
  "ho chi minh city": "272",
  "hobbiton movie set": "46858",
  "hoi an": "831",
  "holetown": "182718",
  "hong kong": "174",
  "honolulu": "261",
  "hooiberg, aruba": "165741",
  "houston": "719",
  "hout bay": "9873",
  "hua hin": "911",
  "huanghuacheng great wall": "96952",
  "hungarian parliament bldg": "3693",
  "hurghada": "403",
  "ʻakaka falls, hawaii": "177118",
  "ibiza": "276",
  "ibiza airport": "130568",
  "ibiza town": "130563",
  "ice pub": "191289",
  "icebar amsterdam": "89712",
  "iceland": "169030",
  "iconsiam": "95117",
  "ifly gold coast": "163113",
  "iguazu falls, argentina": "540",
  "ile-de-france": "965",
  "ilfracombe, queensland": "192558",
  "ilha grande": "34113",
  "illuzion phuket": "225233",
  "innsbruck": "164",
  "interlaken": "793",
  "inverness": "1935",
  "isla mujeres": "1078",
  "island of hawaii": "661",
  "isle of wight": "32682",
  "istanbul": "56",
  "istanbul airport": "163973",
  "izmir": "1082",
  "jack the ripper tours": "148872",
  "jaco": "667",
  "jacobite steam train": "91457",
  "jade cavern, cozumel": "180330",
  "jaipur": "1149",
  "jaisalmer": "32220",
  "jakarta": "278",
  "jamaica": "169118",
  "jamaica beach": "162864",
  "jamaica market": "116237",
  "jamaica street studios": "213421",
  "jamaica town": "219095",
  "james bond island": "158697",
  "japan": "169034",
  "jardin d'acclimatation": "5311",
  "jeddah": "99843",
  "jerez de la frontera": "413",
  "jerusalem": "97",
  "jiankou great wall": "96976",
  "jodhpur": "1883",
  "johan cruijff arena": "3020",
  "johannesburg": "104",
  "jorullo bridge": "163531",
  "jumeirah beach": "7614",
  "jungfraujoch": "45647",
  "jungle island": "11035",
  "juyongguan great wall": "95081",
  "kaikoura": "37419",
  "kathmandu": "101",
  "kauai": "659",
  "key west": "552",
  "key west airport": "178789",
  "key west aquarium": "110267",
  "key west conservatory": "61413",
  "key west first legal rum distillery": "163105",
  "key west historic seaport": "129953",
  "key west lighthouse": "128703",
  "key west theater": "169581",
  "khao lak": "32472",
  "khao sok national park": "2674",
  "king power mahanakhon": "97018",
  "kingston": "322",
  "kirstenbosch bot grdn": "3863",
  "kiruna": "89537",
  "klong muang beach": "9426",
  "knysna": "845",
  "ko chang": "2677",
  "ko lanta": "32301",
  "ko lao lading": "112557",
  "ko phangan": "5038",
  "ko samui": "898",
  "ko tao": "1563",
  "koblenz": "529",
  "kotor": "32202",
  "krabi": "2174",
  "krabi airport": "89920",
  "krabi elephant care house": "188453",
  "krabi elephant shelter": "185774",
  "krabi hot springs": "147138",
  "krabi province": "2172",
  "krabi roaming elephant sanctuary": "227748",
  "krabi town night market": "240419",
  "krakow": "40",
  "kuala lumpur": "171",
  "kuta lombok beach": "227556",
  "kuzá beach & adventure park - cozumel": "243447",
  "kyoto": "96826",
  "la fortuna": "1904",
  "la gaulette": "110572",
  "la spezia": "1348",
  "lady of guadalupe church": "94886",
  "laie hawaii temple": "159290",
  "lake como": "63",
  "lake placid, queensland": "239415",
  "land's end": "92285",
  "langkawi": "903",
  "lanzarote": "421",
  "lapland": "2652",
  "las vegas": "58",
  "last supper": "4955",
  "lautoka": "2473",
  "lawai pottery village": "234761",
  "le morne": "174821",
  "leeward settlement": "189378",
  "leipzig": "25",
  "lethe": "173427",
  "levi": "150197",
  "liberia": "381",
  "lima": "39",
  "lion's head": "3867",
  "lisbon": "42",
  "little havana": "162597",
  "liverpool": "210",
  "lombok": "2412",
  "lombok airport": "167722",
  "lombok timur regency": "216947",
  "lombok utara regency": "216592",
  "london": "57",
  "long bay hills": "250074",
  "loro parque": "4766",
  "los angeles": "179",
  "los arcos": "236374",
  "los arcos marine park": "163368",
  "los cabos": "264",
  "los cabos airport": "144460",
  "los cristianos": "103407",
  "los muertos beach": "163528",
  "louvre museum": "3224",
  "lovers beach": "113132",
  "lower carlton": "165909",
  "lucea": "144503",
  "lucerne": "867",
  "luna park": "3737",
  "luxembourg": "430",
  "luxor": "109",
  "lyon": "295",
  "maafushi": "159192",
  "madeira": "67",
  "madrid": "46",
  "mahébourg": "2084",
  "malaga": "402",
  "maldives": "169135",
  "malé": "159176",
  "malecon boardwalk": "211826",
  "mallorca": "47",
  "mallory square": "139601",
  "malta": "90",
  "mamita's beach club": "168264",
  "manchester": "1128",
  "mangoes restaurant": "128713",
  "manhattan": "3459",
  "manly": "180209",
  "manoa chocolate hawaii": "167129",
  "manuel antonio": "142888",
  "mapleton, queensland": "214579",
  "marbella": "1217",
  "marina vallarta, mexico": "165506",
  "market 23, cancun": "125688",
  "market 28, cancun": "149271",
  "marrakesh": "208",
  "marsa alam": "422",
  "martha brae": "193284",
  "maui": "657",
  "maui bamboo forest": "36492",
  "maui ku'ia estate": "163580",
  "maui nui golf club": "187147",
  "maui ocean center": "36881",
  "maui pineapple farm": "245431",
  "maui pineapple winery": "183719",
  "mauritius": "2105",
  "mauritius airport": "114472",
  "medellin": "1215",
  "melbourne": "202",
  "mexico city": "194",
  "miami": "176",
  "miami airport": "134567",
  "miami beach": "33437",
  "miami beach, barbados": "220637",
  "miami-dade county": "205358",
  "michaelmas cay": "8290",
  "michamvi beach, zanzibar": "240983",
  "milan": "139",
  "miracle garden": "3351",
  "mont-tremblant, quebec": "32383",
  "montego bay": "238",
  "monteverde": "2135",
  "montreal": "195",
  "montreux": "32355",
  "moon palace cancun": "200660",
  "morne seychelles national park": "161793",
  "mosque of the turks": "211823",
  "moulin rouge": "2604",
  "mount etna": "1901",
  "muang krabi": "214034",
  "mullins": "182709",
  "munich": "26",
  "muscat": "233",
  "musée d'orsay": "2976",
  "museo frida kahlo": "198066",
  "museo histórico aruba": "236868",
  "museum of ice cream miami": "214515",
  "museum of the future": "167752",
  "mykonos": "472",
  "nadi": "2472",
  "nagoya": "32669",
  "nairobi": "267",
  "naples": "162",
  "nashville": "1279",
  "nassau": "326",
  "national museum aruba": "233571",
  "natural bridge aruba": "165709",
  "nausori": "143144",
  "navala": "241339",
  "navua": "229277",
  "nazaré": "1916",
  "negril": "323",
  "neuschwanstein castle": "528",
  "new cape point lighthouse": "10460",
  "new delhi": "231",
  "new orleans": "370",
  "new york": "59",
  "newport beach": "95366",
  "nha trang": "1226",
  "niagara falls": "87891",
  "niagara falls, new york": "87888",
  "nice": "314",
  "nickelodeon waterpark": "168797",
  "nine mile": "176219",
  "ninh binh": "1232",
  "nogalito ecopark": "163533",
  "noord": "1101",
  "north andros, bahamas": "255530",
  "north eleuthera, bahamas": "255531",
  "north island": "32634",
  "north queensland": "89085",
  "north rhine-westphalia": "1924",
  "nosara": "184507",
  "notre dame cathedral": "3230",
  "nudey beach": "184958",
  "nuremberg": "127",
  "nusa penida": "89276",
  "oahu": "4966",
  "oaxaca": "681",
  "occidental costa cancun": "183626",
  "ocean beach ibiza": "96733",
  "ocean drive": "10757",
  "ocho rios": "325",
  "oistins": "182705",
  "okinawa": "2937",
  "old slave market zanzibar": "221219",
  "old town": "26125",
  "old town, krakow": "5131",
  "old town, phuket": "105003",
  "omiš": "2096",
  "one vanderbilt": "164288",
  "oranjestad": "341",
  "orlando": "191",
  "osaka": "1204",
  "oskar schindler's factory": "5084",
  "oslo": "38",
  "oslofjord": "4240",
  "oswiecim": "147222",
  "ottawa": "285",
  "outback queensland": "193249",
  "ouzoud waterfalls": "1890",
  "oxford": "441",
  "pacific harbour": "32373",
  "palace of versailles": "317",
  "palais garnier": "3218",
  "palermo": "387",
  "palm cay bahamas": "250422",
  "palo maria waterfall": "229423",
  "pamplemousses": "110327",
  "panama city": "811",
  "pantai seger kuta lombok": "240439",
  "pantheon": "2897",
  "paphos": "426",
  "paraty": "1845",
  "paris": "16",
  "park güell": "3032",
  "parque los fundadores": "163484",
  "pattaya": "182",
  "pearl island bahamas": "149089",
  "perth": "385",
  "phi phi islands": "9477",
  "phra nang beach": "112142",
  "phu quoc": "1219",
  "phuket": "32123",
  "phuket airport": "89091",
  "phuket city": "187",
  "phuket elephant care": "192655",
  "phuket elephant reserve": "200596",
  "phuket elephant sanctuary": "218118",
  "pio secreto reserve": "32806",
  "pirates of the caribbean": "193656",
  "playa d'en bossa": "2588",
  "playa de talamanca": "191727",
  "playa del carmen": "308",
  "playa del carmen archaeological site": "222655",
  "playa den bossa beach": "181698",
  "playa flamingo": "1548",
  "playacar": "4456",
  "plaza del pitillal": "164576",
  "point lookout, queensland": "214865",
  "pointe aux biches": "110407",
  "pompei, campania": "156880",
  "port antonio": "324",
  "port louis": "1858",
  "portal de ses taules": "194297",
  "portal maya": "233619",
  "porters": "182713",
  "porto": "151",
  "prague": "10",
  "prague castle": "2720",
  "prophet elias, santorini": "226163",
  "prospect": "182717",
  "providence, seychelles": "257133",
  "puerto limón": "380",
  "puerto rico gran canaria": "134977",
  "puerto vallarta": "265",
  "puerto vallarta airport": "165505",
  "puerto vallarta port": "178884",
  "puerto viejo de talamanca": "158223",
  "puffing billy railway": "5712",
  "punta cana": "411",
  "punta cancun": "203222",
  "puntarenas": "32285",
  "qc terme milan": "168196",
  "quebec": "561",
  "quebec city": "281",
  "queensland": "567",
  "queensland art gallery": "249927",
  "queensland beach nova scotia": "221233",
  "queensland parliament": "230086",
  "queenstown": "498",
  "quepos": "32284",
  "quito": "504",
  "raccoon island miami": "241370",
  "railay beach": "33131",
  "reef fleet terminal": "104043",
  "regensburg": "470",
  "réunion": "97455",
  "reykjavik": "30",
  "rhodes": "409",
  "riga": "213",
  "rigatoni ibiza": "250879",
  "rio de janeiro": "9",
  "ripley museum cancun": "191819",
  "river thames": "2707",
  "riviera cancun golf": "190309",
  "riyadh": "153731",
  "robben island": "3860",
  "rockefeller center": "3379",
  "rome": "33",
  "rotorua": "1398",
  "rotterdam": "37",
  "rottnest island": "1866",
  "rovaniemi": "2653",
  "royal hawaiian center": "245847",
  "royal hawaiian theater": "242284",
  "royal palace of madrid": "3611",
  "ruka": "192178",
  "runaway bay": "32276",
  "rynek underground": "90189",
  "sabeto": "236486",
  "sagrada familia": "2699",
  "salzburg": "4",
  "samara": "179139",
  "san francisco": "61",
  "san josé": "379",
  "san jose del cabo": "967",
  "san miguel de cozumel": "141611",
  "sansevero chapel": "3799",
  "santa claus village": "93203",
  "santa cruz": "111930",
  "santa maria cathedral": "249521",
  "santa teresa": "2458",
  "santiago de querétaro": "1170",
  "santiago, chile": "226",
  "santino playa": "250719",
  "santorini": "753",
  "santorini airport": "148402",
  "santorini caldera": "174556",
  "santorini cruise port": "169941",
  "santorini volcano": "9788",
  "santorini wine museum": "123240",
  "santorini zen spa": "169264",
  "sarandë": "122815",
  "savaneta": "111940",
  "sea life sydney aquarium": "17631",
  "sea world": "83073",
  "segovia": "1694",
  "seine river": "2601",
  "seoul": "197",
  "sète": "165495",
  "seventh heaven fiji": "190779",
  "seville": "48",
  "seychelles": "169173",
  "seychelles airport": "167859",
  "seychelles beach": "252533",
  "sharm el-sheikh": "408",
  "shipwreck museum": "110272",
  "siem reap": "274",
  "sigatoka": "103953",
  "singapore": "170",
  "single fin bali": "224179",
  "sint nicolaas": "342",
  "skypoint observation deck": "48974",
  "smathers beach": "166868",
  "snorkel el cielo cozumel": "220242",
  "sofia": "158",
  "somerset, queensland": "216345",
  "sorrento": "391",
  "sousse": "478",
  "south andros, bahamas": "255535",
  "south beach": "3925",
  "south caribbean coast": "202236",
  "southern great barrier": "189502",
  "southernmost point buoy": "139606",
  "southport": "4679",
  "spanish wells, bahamas": "4040",
  "speightstown": "159908",
  "spice farm, zanzibar": "192799",
  "split": "268",
  "springbrook national park": "89938",
  "st bartholomew the great": "228881",
  "st. mary parish, jamaica": "165416",
  "st.martins": "182697",
  "stair of the turks": "96430",
  "star island": "145522",
  "statue of liberty": "2612",
  "stingray beach cozumel": "158480",
  "stirling": "2624",
  "stockholm": "50",
  "strasbourg": "293",
  "summit one vanderbilt": "165436",
  "sunset key": "220293",
  "superblue miami": "170054",
  "surfers paradise": "998",
  "surfers paradise beach": "160828",
  "suva": "1578",
  "swag ibiza club": "221190",
  "sydney": "200",
  "sydney airport": "128823",
  "sydney cricket ground": "17642",
  "sydney harbour": "91272",
  "sydney harbour bridge": "3730",
  "sydney opera house": "3729",
  "sydney opera house concert hall": "90314",
  "sydney tower": "3735",
  "sydney zoo": "165692",
  "table mountain": "3858",
  "table mountain cableway": "187861",
  "table mountain np": "254433",
  "tahiti": "32413",
  "tahiti beach": "175357",
  "tallinn": "394",
  "tamarin": "110542",
  "tamarindo": "995",
  "tangier": "835",
  "taronga zoo": "3734",
  "tasty teas bahamas": "169973",
  "tbilisi": "1379",
  "tenerife": "350",
  "than bok khorani park": "189036",
  "the garden": "182712",
  "the library koh samui": "193595",
  "the london eye": "2711",
  "the maui butterfly farm": "166626",
  "the nile": "35186",
  "the pyramid cancun": "223718",
  "the rocks": "3733",
  "the safari blue, zanzibar": "249202",
  "the white house": "2694",
  "thessaloniki": "115",
  "thoddoo": "159186",
  "thulusdhoo": "159203",
  "tiger cave temple": "89243",
  "tiger kingdom phuket": "192665",
  "tirana": "2468",
  "tivoli gardens": "3819",
  "tokyo": "193",
  "tolantongo caves": "168891",
  "toledo": "663",
  "top of the rock observation deck": "3361",
  "toronto": "177",
  "torremolinos": "826",
  "tortuguero": "179461",
  "trinity inlet": "176578",
  "tromsø": "32375",
  "tropical north queensland": "89082",
  "trou d'eau douce": "32321",
  "trou-aux-biches": "145280",
  "truman little white house": "160165",
  "tubkaek beach": "185823",
  "tulum": "248",
  "turin": "390",
  "turks and caicos islands": "169188",
  "tuscany": "558",
  "twin falls maui waterfall": "140236",
  "two oceans aquarium": "3862",
  "ubud": "32246",
  "udaipur": "1930",
  "uffizi gallery": "3953",
  "ulaanbaatar": "968",
  "uluru": "1899",
  "uluwatu": "105742",
  "underground naples": "89414",
  "universal orlando resort": "3848",
  "universal studios": "5014",
  "universal studios florida": "181174",
  "universal studios japan": "80971",
  "universal studios sg": "4045",
  "university of queensland": "248073",
  "upcountry maui": "89914",
  "us1 – mile marker 0": "144583",
  "ushuaia": "1851",
  "utrecht": "32279",
  "uvita": "187790",
  "uyuni": "32222",
  "uyuni salt flat": "95303",
  "v&a waterfront": "3861",
  "valencia": "49",
  "valletta": "1195",
  "valley of the kings": "73249",
  "van gogh museum": "2695",
  "vancouver": "189",
  "vang vieng": "2838",
  "varanasi": "32154",
  "varso tower observation deck": "248937",
  "vatican city": "524",
  "vatican museums": "2738",
  "veisabasaba village": "98076",
  "venice": "35",
  "verona": "389",
  "versailles": "147798",
  "versalles": "254338",
  "victoria": "551",
  "vienna": "7",
  "vienna state opera": "3941",
  "vik": "32622",
  "villa borghese": "2907",
  "vilnius": "245",
  "viseisei": "116980",
  "vizcaya museum & gardens": "3926",
  "vltava river": "4971",
  "vou hub fiji": "166201",
  "w koh samui": "193596",
  "waiheke island": "2324",
  "waikiki": "141476",
  "waimea, island of hawaii": "119350",
  "waitomo caves": "35827",
  "walt disney world": "5019",
  "wanaka": "946",
  "warner bros. movie world": "83070",
  "warner bros. studio": "4745",
  "warsaw": "41",
  "washington, dc": "62",
  "wat phra yai koh samui": "193506",
  "waterbom bali": "84532",
  "wave break island": "143275",
  "wawel royal castle": "4142",
  "welchman hall": "222453",
  "wellington": "943",
  "wellshot centre": "192560",
  "wellshot hotel": "192559",
  "west bali national park": "97162",
  "west end, bahamas": "212018",
  "west lombok regency": "216589",
  "west maui mountains": "163416",
  "westminster abbey": "2710",
  "wet'n'wild": "83062",
  "whistler": "282",
  "white house": "180014",
  "whitehaven beach": "34960",
  "whitsunday coast airport": "123190",
  "whitsunday islands": "7930",
  "whitsunday national park": "169884",
  "whitsunday regional": "165164",
  "wieliczka salt mine": "4139",
  "wiener musikverein hall": "3530",
  "winter wonderland": "181140",
  "witzands aquifer reserve": "138626",
  "wondr experience": "141651",
  "wroclaw": "2036",
  "würzburg": "133",
  "wynwood arts district": "10754",
  "wynwood walls": "166715",
  "xcaret park": "4454",
  "xi'an": "270",
  "xline dubai": "200975",
  "xochimilco": "2233",
  "xplor park": "4736",
  "yala national park": "97530",
  "yarra river": "32696",
  "yas island": "3685",
  "yas island marina circuit": "3683",
  "yellowstone national park": "993",
  "yerevan": "1406",
  "yogyakarta": "349",
  "yokohama": "2128",
  "yona beach club": "192123",
  "york": "436",
  "yucatán": "227",
  "yves saint laurent museum": "108832",
  "zaanse schans": "2255",
  "zadar": "1328",
  "zagreb": "803",
  "zakopane": "1554",
  "zakynthos": "32286",
  "zanzibar": "871",
  "zanzibar airport": "143574",
  "zanzibar aquarium": "237477",
  "zanzibar archipelago": "95591",
  "zanzibar butterfly center": "220467",
  "zanzibar city": "872",
  "zermatt": "1514",
  "zhangjiajie": "1047",
  "zip fiji nadi": "98061",
  "zona romantica": "94883",
  "zoo miami": "3511",
  "zurich": "55"
};
